// Sentry initialization. This file MUST be the first import in index.js — the SDK
// can only instrument what loads after it.
//
// The DSN comes from REACT_APP_SENTRY_DSN (CRA inlines REACT_APP_* at build time).
// With no DSN set the SDK is inert, so unconfigured environments cost nothing.
import React from 'react';
import * as Sentry from '@sentry/react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';

const isProduction = process.env.NODE_ENV === 'production';

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,

    dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
        // userInfo: false,
        // httpBodies: [],
    },

    integrations: [
        // Hook-based form, not wrapCreateBrowserRouterV6: index.js mounts a plain
        // <BrowserRouter>, so there is no router object to wrap. Without this,
        // navigation transactions are named by raw URL instead of route pattern.
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            matchRoutes,
            createRoutesFromChildren,
        }),
    ],

    // 1.0 in dev so every navigation shows up while wiring this; sampled down in
    // production, where the portal's traffic makes full capture pointless volume.
    tracesSampleRate: isProduction ? 0.1 : 1.0,
});
